import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';

import UsersDataTable from './components/UsersDataTable/UsersDataTable';

const useStyles = makeStyles((theme) => ({
	root: {},
	deliverables: {
		marginTop: theme.spacing(3),
	},
	members: {
		marginTop: theme.spacing(3),
	},
}));

const Users = (props) => {
	const { users, className, ...rest } = props;

	const classes = useStyles();
	return (
		<Grid2
			{...rest}
			className={clsx(classes.root, className)}
			container
			spacing={3}
		>
			<Grid2 item size={12}>
				<UsersDataTable data={users} />
			</Grid2>
		</Grid2>
	);
};

Users.propTypes = {
	className: PropTypes.string,
	users: PropTypes.array.isRequired,
};

export default Users;
